import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';import PageMeta from '../../components/common/PageMeta';
import ComponentCard from '../../components/common/ComponentCard';
import Button from '../../components/ui/button/Button';
import SpecialOccasionMenusTable from './SpecialOccasionMenusTable';

const apiUrl = process.env.REACT_APP_API_URL;

type SpecialMenuPermissions = {
  view: boolean;
  add: boolean;
  update: boolean;
  delete: boolean;
};

const defaultPermissions: SpecialMenuPermissions = {
  view: false,
  add: false,
  update: false,
  delete: false,
};

const SpecialOccasionMenus = () => {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState<SpecialMenuPermissions>(defaultPermissions);
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(true);

  useEffect(() => {
    const fetchAccess = async () => {
      const token = localStorage.getItem("token");

      if (!apiUrl) {
        setIsLoadingPermissions(false);
        return;
      }

      try {
        const response = await fetch(`${apiUrl}/auth/access`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token: token || "",
          },
        });

        if (response.status === 401) {
          localStorage.removeItem("token");
          navigate("/signin");
          return;
        }

        const result = await response.json();
        const access = result?.specialmenus;

        if (access && typeof access === "object") {
          const nextPermissions: SpecialMenuPermissions = {
            view: Boolean(access.view),
            add: Boolean(access.add),
            update: Boolean(access.update),
            delete: Boolean(access.delete),
          };

          setPermissions(nextPermissions);

          if (!nextPermissions.view) {
            navigate("/");
            return;
          }
        } else {
          navigate("/");
          return;
        }
      } catch {
        navigate("/");
        return;
      } finally {
        setIsLoadingPermissions(false);
      }
    };

    fetchAccess();
  }, [navigate]);

  if (isLoadingPermissions) {
    return null;
  }

  return(
    <>
      <PageMeta 
        title="Special Occasion Menus | Hospitality Genie"
        description="Special Occasion Menus page of Hospitality Genie, where you can manage and create special occasion menus for your restaurant."
      />
      <div className="space-y-6">
      <ComponentCard title="Menu - Special Occasion Menus">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">Special Occasion Menus</div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            {permissions.add && (
              <Button
                className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]" size="sm" 
                onClick={() => navigate('/add-special-occasion-menu')}
              >
                Add New Special Menu
              </Button>
            )}
            </div>
        </div>
        
        <div>
          <SpecialOccasionMenusTable />
        </div>
      </ComponentCard>
      </div>
    </>
  );

}

export default SpecialOccasionMenus;
